// This is a mixin which provides an object with the ability extract values from the URL.

import {valueFromUrlParams} from "../../helpers/url";

export function MixinUrlConfigurable(obj) {
    mixinMethods(obj);
}

function mixinMethods(obj) {
    Object.assign(obj.__proto__, {

            // Extract the value of a key from the URL query string. Based on the value type we might need to do some parsing.
            valueFromUrlQueryString(key, valueType = 'string') {
                return valueFromUrlParams(key, valueType);
            }

        }
    )
    ;
}



